import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import style from '../Debug.module.scss';

const warnings = {
  Tomato:
    'Please note: Testing with the tomato screens baseUrl will also enable clientless APIs during this test',
};

const ApiPanel = (props = {}) => {
  const { baseUrls, currentBaseUrl, handleSetApiBaseUrl } = props;

  const baseUrlOptions = _.map(baseUrls, (key, value) => (
    <option value={value} key={key} selected={currentBaseUrl === value}>
      {value}
    </option>
  ));
  const baseUrlValue = _.get(baseUrls, currentBaseUrl);
  const warning = _.get(warnings, currentBaseUrl);
  const warningComp = warning && <div className={style.formWarning}>{warning}</div>;
  return (
    <div className={style.panel}>
      <div className={style.header}>Content API</div>
      <div className={style.body}>
        <div className={style.formLabel}>Base url: {baseUrlValue}</div>
        {warningComp}
        <div>
          <select onChange={handleSetApiBaseUrl}>
            <option value={null} selected={!currentBaseUrl} />
            {baseUrlOptions}
          </select>
        </div>
      </div>
    </div>
  );
};

export default ApiPanel;

ApiPanel.defaultProps = {
  baseUrls: null,
  currentBaseUrl: null,
  handleSetApiBaseUrl: () => {},
};

ApiPanel.propTypes = {
  baseUrls: PropTypes.shape({}),
  currentBaseUrl: PropTypes.string,
  handleSetApiBaseUrl: PropTypes.func,
};
